import React from 'react';
import MainTitle from '../../components/page/main-title/MainTitle';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import TextInputWithUploader from '../../components/form/TextInputWithUploader';
import TextArea from "../../components/form/TextArea";
import SelectAjax from "../../components/form/SelectAjax";
import ItemSimplesListagem from '../../components/listagem/ItemSimplesListagem';
import STRINGS from './../../data/language/language';
import Random from "../../utils/strings/Random";
import {FormDataToJson} from '../../utils/json/Json';
import Dialog from '../../components/alert/Dialog';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import PAGES from '../../config/Pages';
const itemIdPrefix = "item-exercicio-";
const URL_SAVE = WS.exercicios.save;

class Page extends React.Component{
  constructor (props){
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getItem = this.getItem.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.state = {
      listagem: props.detalhe ? this.getVideosDetalhe() : [],
      wrapper:Random(7),
      strings:STRINGS[window.LANGUAGE],
      detalhe: props.detalhe
    }
  }

  componentDidMount() {
  }

  componentWillUnmount() {

  }

  getVideosDetalhe (){
    const videos = this.props.detalhe.videos;
    let array = [];
    const self = this;

    if(videos){
      videos.forEach(function(valor, chave){
          array.push(self.getItem(valor));
      });
    }

    return array;
  }

  getItem (__args__){
    let _prefix = itemIdPrefix;
    const _value = __args__.label;
    const _identifier = _prefix+__args__.value;
    const _id = __args__.value;
    return <ItemSimplesListagem
      key={Math.floor(Math.random()*1000)}
      value={_value}
      id={_id}
      identifier={_identifier}
      hideEdit={true}>
    </ItemSimplesListagem>;
  }

  handleSelectChange (newValue) {
    this.addVideo(newValue);
  }

  addVideo (newValue){
    var listagem = [];

    if(this.state.listagem){
      listagem = this.state.listagem;
    }else{
      this.setState({listagem:[]});
    }
    const item = this.getItem(newValue);
    const _arr = [...listagem, item];
    this.setState({listagem:_arr});
  }

  handleSubmit (e){
    e.preventDefault();

    const _self = this;
    const {
      atencao,
      salvoSucesso,
      erroSalvarBloco,
      preenchaCamposAsterisco,
      escolhaOsExercicios,
      erroSalvar
    }
    = this.state.strings;

    const formData = new FormData(e.target);

    //retorna todos os exercicios adicionados
    let idForm = e.target.getAttribute('id');
    let elements = document.getElementById(idForm).querySelectorAll('.item-listagem');
    var exercicios = [];

    //transforma o formData em um json
    var object = FormDataToJson(formData);

    if(object.nome === ''){
      let msg = {
        title: atencao,
        text:preenchaCamposAsterisco
      };
      Dialog.create(msg);
      return false;
    }

    //é obrigatório adicionar exercícios
    if(elements.length<=0){
      let msg = {
        title: atencao,
        text:escolhaOsExercicios
      };
      Dialog.create(msg);
      return false;
    }

    elements.forEach((value, key)=>{
      let idEl = value.getAttribute('data-id');
      if(idEl){
        exercicios.push(idEl);
      }

    });

    object.videos = exercicios;

    const history = this.props.history;

    //----------------

    Requisitions({
      url:URL_SAVE,
      data: object,
      sucess:function(data){
        var msg;
        _self.props.modal.close();
        history.push(PAGES.exercicios);
        msg = {
          title: atencao,
          text: data.msg
        };
        Dialog.create(msg);
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroSalvar
        });
      }
    });
  }

  render (){
    const {
      fieldNome,
      fieldDigiteNome,
      imagemMasculina,
      imagemFeminina,
      cadastroExercicio,
      selecioneVideo,
      salvar,
      observacoes,
      selecioneExercicios
    } = this.state.strings;
    const {listagem} = this.state;
    const lista = listagem.length ? <div className="listagem-border">{listagem}</div> : null;
    const nome_video = this.props.detalhe ? this.props.detalhe.titulo : '';
    const img_feminina = this.props.detalhe ? this.props.detalhe.imagem_feminina : '';
    const img_masculina = this.props.detalhe ? this.props.detalhe.imagem_masculina : '';
    const observacoesVal = this.props.detalhe ? this.props.detalhe.observacoes : '';
    const id = this.props.detalhe ? <input type='hidden' name='id' value={this.props.detalhe.id} />   : '';

    return (
      <div>
        <MainTitle title={cadastroExercicio}></MainTitle>
        <form className="" id={this.state.wrapper} onSubmit={this.handleSubmit}>
          {id}
          <div className="">
            <TextInput value={nome_video} name="titulo" title={fieldNome+"*"} placeholder={fieldDigiteNome}></TextInput>
          </div>
          <div>
            <div className="pure-u-1-2 hide">
              <TextInputWithUploader value={img_feminina} name="imagem_feminina" title={imagemFeminina} placeholder=""></TextInputWithUploader>
            </div>
            <div className="pure-u-1-2 hide">
              <TextInputWithUploader value={img_masculina} name="imagem_masculina" title={imagemMasculina} placeholder=""></TextInputWithUploader>
            </div>
            <div className="pure-u-1-2">
              <SelectAjax  url={WS.videos.search} onChange={this.handleSelectChange}  title={selecioneVideo+"*"} />
            </div>
            <div className="listagem">
              {lista}
            </div>
          </div>
          <div className="">
            <TextArea value={observacoesVal} name="observacoes" title={observacoes} placeholder=""></TextArea>
          </div>
          <br /><br />
          <div className="box-right-button"><Button type="submit" text={salvar} classes="bt-save bt-blue" /></div>
        </form>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/exercicios/Page.js